import { useRouter } from "next/router";
import { isOrtexApp } from "@/lib/utils";
import { Box, Button, Typography } from "@mui/material";
import { useAtomValue, useSetAtom } from "jotai";
import useAppSubscriberUpgrade from "src/hooks/useAppSubscriberUpgrade";
import { UPGRADE_LOCATIONS, trackUpgradeClick } from "@/lib/tracking";
import { textColorState, themeState, whiteDarkerState, blackLighterState, userState, planPickerDrawerOpenState } from "@/lib/store";

const SubscriptionBanner = () => {
    const textColor = useAtomValue(textColorState);
    const theme = useAtomValue(themeState);
    const whiteDarker = useAtomValue(whiteDarkerState);
    const blackLighter = useAtomValue(blackLighterState);
    const user = useAtomValue(userState);
    const setPlanPickerOpen = useSetAtom(planPickerDrawerOpenState);

    const { handleAppSubscriberUpgrade } = useAppSubscriberUpgrade();
    const router = useRouter();

    const handleClick = () => {
        trackUpgradeClick(UPGRADE_LOCATIONS.SUBSCRIPTION_BANNER, { plan: user?.subscription_plan });
        if (user.subscription_plan === "ORTEX Visitor") router.push("/login?register=true");
        else if (isOrtexApp()) setPlanPickerOpen(true);
        else handleAppSubscriberUpgrade();
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100%",
                width: "100%",
                py: 4,
                px: 2,
                textAlign: "center",
            }}
        >
            <Typography variant="h5" sx={{ fontWeight: 700, color: textColor, mb: 1 }}>
                Subscribe to Access Full Content
            </Typography>
            <Typography variant="body2" sx={{ color: theme === "dark" ? whiteDarker : blackLighter, mb: 3, maxWidth: 360 }}>
                Upgrade for more valuable insights.
            </Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "center", mb: 3 }}>
                <Button variant="contained" color="primary" onClick={handleClick} sx={{ textTransform: "none", fontWeight: 600 }}>
                    Upgrade Now
                </Button>
            </Box>
        </Box>
    );
};

export default SubscriptionBanner;
